import Value from './Section'

export default {
	label: 'Reservation Confirmation Page',
	group: 'content',
	Value,
	defaultValue: {
		contractId: null,
	},
}
